import { createAction, props } from '@ngrx/store';
import { ApiPagingConfig } from 'src/app/shared/models/paging/ApiPagingConfig';
import { ListCardItem } from 'src/app/shared/components/cards/list-card/models/ListCardItem';

export const AnnouncementsActionTypes = {
  GET_ANNOUNCEMENTS: '[ANNOUNCEMENTS] get announcements',
  CLEAR_ANNOUNCEMENTS: '[ANNOUNCEMENTS] clear announcements',
  GET_ANNOUNCEMENTS_SUCCESS: '[ANNOUNCEMENTS] get announcements success',
  GET_ANNOUNCEMENT: '[ANNOUNCEMENTS] get announcement',
  CLEAR_ANNOUNCEMENT: '[ANNOUNCEMENTS] clear announcement',
  GET_ANNOUNCEMENT_SUCCESS: '[ANNOUNCEMENTS] get announcement success'
};

export const GetAnnouncements = createAction(
  AnnouncementsActionTypes.GET_ANNOUNCEMENTS,
  props<{
    paging: ApiPagingConfig;
  }>()
);

export const GetAnnouncementsSuccess = createAction(
  AnnouncementsActionTypes.GET_ANNOUNCEMENTS_SUCCESS,
  props<{
    announcements: [];
    totalCount: string;
  }>()
);

export const GetAnnouncement = createAction(
  AnnouncementsActionTypes.GET_ANNOUNCEMENT,
  props<{ id: string }>()
);

export const GetAnnouncementSuccess = createAction(
  AnnouncementsActionTypes.GET_ANNOUNCEMENT_SUCCESS,
  props<{ announcement: ListCardItem }>()
);

export const ClearAnnouncements = createAction(
  AnnouncementsActionTypes.CLEAR_ANNOUNCEMENTS
);

export const ClearAnnouncement = createAction(
  AnnouncementsActionTypes.CLEAR_ANNOUNCEMENT
);
